import React from "react";

const STAGE_CONTENT = {
  catalog: {
    method: "GET",
    path: "/v1/partner/vehicle-types",
    dim: "Authorization: Bearer qt_live_…",
    body: null,
    status: "200 OK",
    response: '"vehicles": [{ "type": "1.5tonopen", ... }]',
  },
  quote: {
    method: "POST",
    path: "/v1/partner/quotes",
    dim: 'Authorization: Bearer qt_live_…',
    body: '{ "trucktype": "1.5tonopen", ... }',
    status: "200 OK",
    response: '"sellingprice": 295000',
  },
  order: {
    method: "POST",
    path: "/v1/partner/orders",
    dim: 'Authorization: Bearer qt_live_…',
    body: '{ "quoteid": "q_8f2a...", ... }',
    status: "201 Created",
    response: '"orderid": "QT-48291"',
  },
  payment: {
    method: "POST",
    path: "/v1/partner/orders/:id/payment",
    dim: 'Authorization: Bearer qt_live_…',
    body: '{ "payer": "end_customer" }',
    status: "200 OK",
    response: '"payment_url": "https://..."',
  },
  track: {
    method: "GET",
    path: "/v1/partner/orders/:id",
    dim: 'Authorization: Bearer qt_live_…',
    body: null,
    status: "200 OK",
    response: '"status": "en_route", "eta_min": 45',
  },
};

export function PartnerApiStageMock({ stage = "quote", size = "lg" }) {
  const data = STAGE_CONTENT[stage] || STAGE_CONTENT.quote;

  return (
    <div className={"qt-api-mock qt-api-mock--" + size} aria-hidden="true">
      <div className="qt-api-mock-head">
        <span className="qt-api-mock-dot" />
        <span className="qt-api-mock-dot" />
        <span className="qt-api-mock-dot" />
        <code>
          {data.method} {data.path}
        </code>
      </div>
      <div className="qt-api-mock-body">
        <div className="qt-api-mock-line qt-api-mock-line--dim">{data.dim}</div>
        {data.body ? <div className="qt-api-mock-line">{data.body}</div> : null}
        <div className="qt-api-mock-response">
          <i className="mdi mdi-check-circle" /> {data.status}
          <div className="qt-api-mock-line">{data.response}</div>
        </div>
      </div>
    </div>
  );
}

export function PartnerApiFlowStrip({ stages, size = "xs" }) {
  return (
    <div className="qt-embed-flow-strip qt-embed-flow-strip--api">
      {stages.map((item, idx) => (
        <React.Fragment key={item.id}>
          <div className="qt-embed-flow-strip__item">
            <PartnerApiStageMock stage={item.id} size={size} />
            <span className="qt-embed-flow-strip__label">{item.label}</span>
          </div>
          {idx < stages.length - 1 ? (
            <div className="qt-embed-flow-strip__arrow" aria-hidden="true">
              <i className="mdi mdi-chevron-right" />
            </div>
          ) : null}
        </React.Fragment>
      ))}
    </div>
  );
}

export default PartnerApiStageMock;
